/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-28 12:13:09
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-02 15:37:16
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/index.ts
 */
import { getI18nFromGeneral } from 'src/tools/tools';

export interface IFixedProps {
  createdDate: string;
  deleted: boolean;
  createdBy: string;
  modifiedBy: string;
  modifiedDate: string;
}

export enum RemindUnitProps {
  Days = 'Days',
  Hours = 'Hours',
  RollingDays = 'RollingDays',
}

export enum EnumPageType {
  //PopupWindowPromotion,
  ContentButton = 'ContentButton',
  ContentText = 'ContentText',
  ContentAnimation = 'ContentAnimation',
  ContentHeader = 'ContentHeader',
  ContentHomePage = 'ContentHomePage',
  ContentPromotionPage = 'ContentPromotionPage',
  ContentPage = 'ContentPage',
  ContentShoppingCartPage = 'ContentShoppingCartPage',
  ContentProfilePage = 'ContentProfilePage',
  ContentAllProductsPage = 'ContentAllProductsPage',
  ContentMaintenancePage = 'ContentMaintenancePage',
  Content404Page = 'Content404Page',
  ContentSearchPage = 'ContentSearchPage',
  ContentTabBar = 'ContentTabBar',
  ContentAppearancePage = 'ContentAppearancePage',
  ContentNavigation = 'ContentNavigation',
  ContentFooter = 'ContentFooter',
  ContentMegaMenu = 'ContentMegaMenu',
  SalesChannelProduct = 'SalesChannelProduct',
  SalesChannelProductContent = 'SalesChannelProductContent',
  SalesChannelProductAlias = 'SalesChannelProductAlias',
  SalesChannelProductCustomisation = 'SalesChannelProductCustomisation',
  SalesChannelCollection = 'SalesChannelCollection',
  SalesChannelLegalPage = 'SalesChannelLegalPage',
  SalesChannelTermsAndConditions = 'SalesChannelTermsAndConditions',
  SalesChannelContent = 'SalesChannelContent',
}
export enum ESort {
  asc = 'ascend',
  desc = 'descend',
}
export enum EDeletionType {
  Selected = 'Selected',
  All = 'All',
}

export enum EUnit {
  'CubicCentimeter' = 'CubicCentimeter',
  'Centimeter' = 'Centimeter',
  'Kilogram' = 'Kilogram',
  Ounce = 'Ounce',
  Pound = 'Pound',
  Gram = 'Gram',
  Milligram = 'Milligram',
}

export const unitDict = {
  [EUnit.Centimeter]: getI18nFromGeneral('general.unit.cm'),
  [EUnit.CubicCentimeter]: getI18nFromGeneral('general.unit.cm3'),
  [EUnit.Kilogram]: getI18nFromGeneral('general.unit.kg'),
  [EUnit.Ounce]: getI18nFromGeneral('general.unit.ounce'),
  [EUnit.Pound]: getI18nFromGeneral('general.unit.pound'),
  [EUnit.Gram]: getI18nFromGeneral('general.unit.g'),
  [EUnit.Milligram]: getI18nFromGeneral('general.unit.mg'),
};

export enum TextAlign {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
  JUSTIFY = 'JUSTIFY',
}

export enum EPlanType {
  NONE = 'None',
  TRIAL = 'Trial',
  BASIC = 'Basic',
  ENTERPRISE = 'Enterprise',
}

export enum EPlanStatus {
  NONE = 'None',
  ACTIVE = 'Active',
  PENDING = 'Pending',
  EXPIRED = 'Expired',
  CANCELLED = 'Cancelled',
}

export const CN_REGION = 'cn-north-1';
